import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IEnrollmentMatrixDto } from '@/dtos';
import { EXPIRED_QUERY_KEY } from '@/modules/ProcessingDefinition/EnrollmentMatrix/queries/useEnrollmentMatrixes.queries';

import { useEnrollmentMatrixStore } from '../../stores/useEnrollmentMatrix.store';

interface EnrollmentMatrixPayload {
  name?: string;
  priority?: number;
  valid_from?: string;
  valid_to?: string;
  organization_id?: number;
  processing_rule_id?: number;
  plan_id?: number;
  plan_year_id?: number;
}

const getActivePageNumber = (elementIndex: number, pageSize: number) => Math.ceil(elementIndex / pageSize);

export const useCreateEnrollmentMatrixQuery = (perPage?: number) => {
  const { setNewAddedEnrollmentMatrixId, setActivePage } = useEnrollmentMatrixStore();
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(
    (payload: EnrollmentMatrixPayload) =>
      api.post<IEnrollmentMatrixDto>(API_URL.ENROLLMENT_MATRIXES, payload),
    {
      onSuccess: (data) => {
        if (data.data.id || data.data.id === 0) setNewAddedEnrollmentMatrixId(`${data.data.id}`);
        if (data.data.priority && perPage) setActivePage(getActivePageNumber(data.data.priority, perPage));
        queryClient.invalidateQueries({
          queryKey: [{ queryKey: [EXPIRED_QUERY_KEY] }],
        });
      },
    }
  );
  return mutateAsync;
};

export default useCreateEnrollmentMatrixQuery;
